import { Hash } from "viem";
import { isHash } from "./isHash";

export const isHashEqual = (hash1?: Hash | null, hash2?: Hash | null) => {
  if (!isHash(hash1) || !isHash(hash2)) {
    return false;
  }
  return hash1.toLowerCase() === hash2.toLowerCase();
};
